import { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import useMetaPixel from './hooks/useMetaPixel';
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Conversas from './pages/Conversations';
import AgentsPage from './pages/AgentsPage';
import Conversations from './pages/Conversations';
// ConversationsList foi unificado dentro do ChatPage (layout 3-col).
// O import permanece comentado pra deixar claro que o arquivo segue no
// repo (caso queira reverter) mas não é mais referenciado pela rota.
// import ConversationsList from './pages/ConversationsList';
import ChatPage from './pages/ChatPage';
import AdminDash from './pages/dashboards/AdminDash';
import CheckoutSuccess from './pages/CheckoutSuccess';
import CheckoutCancel from './pages/CheckoutCancel';

// ── Páginas Administrativas ──────────────────────────────────────────────────
import AdminChips from './pages/UserAdmin/AdminChips';
import AdminUpgrade from './pages/UserAdmin/AdminUpgrade';
import AdminAssinatura from './pages/UserAdmin/AdminAssinatura';
import AdminMeta from './pages/UserAdmin/AdminMeta';
import AgendaPage from './pages/agenda/AgendaPage';
import Contacts from './pages/UserAdmin/Contacts';
import AccountSettings from './pages/UserAdmin/AccountSettings';
import AdminIntegracoes from './pages/UserAdmin/AdminIntegracoes';
import Automacao from './pages/Automacao';
import FormulariosPage from './pages/formularios/FormulariosPage';

// Landing (out/26, pages/landing/): carrega sob demanda — quem usa o app
// não baixa o tour nem as telas de produto da LP.
const LandingNova = lazy(() => import('./pages/landing/LandingNova'));
const QuemSomos = lazy(() => import('./pages/landing/QuemSomos'));
const fundoLp = <div style={{ minHeight: '100vh', background: '#0a0f1a' }} />;

// Lê o token a cada render (não no mount do App), pra que o redirect reflita
// o estado atual de localStorage logo após o login.
function RequireAuth({ children, fallback = '/' }) {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to={fallback} replace />;
}

function App() {
  // Meta Pixel PageView em rotas públicas (ver src/hooks/useMetaPixel.js).
  // Não dispara nada quando o user está logado — LGPD + eficiência de mídia.
  useMetaPixel();

  return (
    <Routes>
      {/* Páginas públicas */}
      <Route path="/" element={<Suspense fallback={fundoLp}><LandingNova /></Suspense>} />
      {/* Endereço da prévia enquanto a LP nova era montada (PRs 1 e 2). */}
      <Route path="/previa-lp" element={<Navigate to="/" replace />} />
      <Route path="/quem-somos" element={<Suspense fallback={fundoLp}><QuemSomos /></Suspense>} />
      <Route path="/login" element={<Login />} />
      <Route path="/recuperar-senha" element={<RecuperarSenha />} />
      <Route path="/register" element={<Register />} />

      {/* Páginas de checkout */}
      <Route path="/checkout/success" element={<CheckoutSuccess />} />
      <Route path="/checkout/cancel" element={<CheckoutCancel />} />

      {/* Páginas protegidas */}
      <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
      <Route path="/conversas" element={<RequireAuth><Conversas /></RequireAuth>} />
      <Route path="/agenda"    element={<RequireAuth fallback="/login"><AgendaPage /></RequireAuth>} />
      <Route path="/agents" element={<AgentsPage />} />
      <Route path="/admin" element={<AdminDash />} />
      <Route path="/conversations/list" element={<Conversations />} />
      {/* ConversationsList legado: agora a lista de conversas vive dentro
          do próprio ChatPage (layout 3-col). Mantemos a rota como redirect
          pro novo /chat/:deviceId pra não quebrar links externos antigos. */}
      <Route path="/conversations/device/:deviceId/list" element={<ChatPage />} />
      <Route path="/chat/:deviceId" element={<ChatPage />} />
      <Route path="/chat/:deviceId/:clientId" element={<ChatPage />} />

      {/* ── Páginas Administrativas ─────────────────────────────────────── */}
      <Route path="/admin/chips"      element={<RequireAuth fallback="/login"><AdminChips /></RequireAuth>} />
      <Route path="/admin/upgrade"    element={<RequireAuth fallback="/login"><AdminUpgrade /></RequireAuth>} />
      <Route path="/admin/assinatura" element={<RequireAuth fallback="/login"><AdminAssinatura /></RequireAuth>} />
      <Route path="/admin/meta"       element={<RequireAuth fallback="/login"><AdminMeta /></RequireAuth>} />
      <Route path="/contatos"         element={<RequireAuth fallback="/login"><Contacts /></RequireAuth>} />
      <Route path="/config-conta"     element={<RequireAuth fallback="/login"><AccountSettings /></RequireAuth>} />
      <Route path="/admin/integracoes" element={<RequireAuth fallback="/login"><AdminIntegracoes /></RequireAuth>} />
      <Route path="/automacao"        element={<RequireAuth fallback="/login"><Automacao /></RequireAuth>} />
      <Route path="/formularios"      element={<RequireAuth fallback="/login"><FormulariosPage /></RequireAuth>} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
